const alertContainer = document.querySelector('.block-alert-top');

//Add height to body for other fixed/absolute elements
if (alertContainer) {
	const alertObserver = new ResizeObserver((entries) => {
		entries.forEach(() => {
			const alertContainerTop = alertContainer.offsetTop;
			const alertContainerHeight = alertContainer.offsetHeight;

			document.body.style.setProperty(
				'--alert-height',
				`${(alertContainerHeight + alertContainerTop) / 16}rem`
			);
		});
	});

	alertObserver.observe(alertContainer);
}

document.addEventListener('DOMContentLoaded', () => {
	const alert = document.querySelector('.block-alert-top');
	const cookieName = 'alert-top';

	if (!alert) {
		return;
	}

	const setCookie = (name, value, days) => {
		const date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		const expires = 'expires=' + date.toUTCString();
		document.cookie =
			name + '=' + JSON.stringify(value) + ';' + expires + ';path=/';
	};

	const getCookie = (name) => {
		const cookieValue = document.cookie.match(
			'(^|;)\\s*' + name + '\\s*=\\s*([^;]+)'
		);
		return cookieValue ? decodeURIComponent(cookieValue.pop()) : null;
	};

	let alertState = JSON.parse(getCookie(cookieName)) || {};

	const setStorage = () => {
		setCookie(cookieName, alertState, 7); // Set cookie with a week expiration
	};

	const alertCloseButton = alert.querySelector('.block-alert-top__close');

	//Close alert item and set cookie
	if (alertCloseButton) {
		alertCloseButton.addEventListener('click', function (e) {
			e.preventDefault();
			alert.classList.add('block-alert-top--hidden');
			alertState = { viewed: true };
			setStorage();
		});
	}

	//No cookie, set all to not viewed
	if (!alertState) {
		alertState = { viewed: false };
		alert.classList.remove('block-alert-top--hidden');
		setStorage();

		return;
	}

	if (alertState.viewed) {
		alert.classList.add('block-alert-top--hidden');
	} else {
		alert.classList.remove('block-alert-top--hidden');
	}
});
